import { useState, useCallback } from 'react';
import type { RegistrationData } from '../types/registration';

export const useRegistrationForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [registrationData, setRegistrationData] = useState<Partial<RegistrationData>>({});

  const steps = [
    'Contact Details',
    'Business Details', 
    'Owner Details',
    'Choose Product'
  ];

  const nextStep = useCallback(() => {
    setCurrentStep(prev => Math.min(prev + 1, steps.length - 1));
  }, [steps.length]);

  const prevStep = useCallback(() => {
    setCurrentStep(prev => Math.max(prev - 1, 0));
  }, []);

  const updateData = useCallback((stepData: Partial<RegistrationData>) => {
    setRegistrationData(prev => ({ ...prev, ...stepData }));
  }, []);

  return {
    currentStep,
    steps,
    registrationData,
    nextStep,
    prevStep,
    updateData,
    setCurrentStep
  };
};